import React, { createRef } from "react";
import { CategoryDetailsState } from "../../states/CategoryDetailsState";
import './CategoryDetailsPage.css';
import * as querystring from 'querystring';
import { Mapper } from "../../utils/Mapper";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import { Button, Radio, TextField } from "@material-ui/core";
import Media from "react-media";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { Route } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { IProductDto } from "../../models/ProductDto";
import _ from "lodash";
import { ProductButton } from "../../components/buttons/product-button/ProductButton";
import { Pagination } from "../../utils/Pagination";
import { AddOrRemoveProductFromCategory } from "../../models/AddOrRemoveProductFromCategory";
import $ from 'jquery';
import CloseMenuIcon from "../../resources/wrappers/menu/CloseMenuIcon";
import { AppUtils } from "../../utils/AppUtils";
import colors from '../../utils/colors.json';
import { CategoryDto } from "../../models/CategoryDto";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import { sessionStorageInstance } from "../../services/storage/Storage";
import { eventDispatcher } from "../../services/events/EventDispatcher";
import { EventType } from "../../services/events/EventType";
import { dataStore } from "../../services/storage/DataStore";

export class CategoryDetailsPage extends React.Component<any, CategoryDetailsState> {
    readonly MAX_CATEGORY_NAME_LENGTH = 30;
    private pagination: Pagination<IProductDto>;
    private updateCategoryNameInput: any;
    constructor(props: any){
        super(props);
        console.log("CategoryDetails props: " + JSON.stringify(props));

        this.state = {
            isLoading: true,
            products: null,
            categoryId: "",
            color: "",
            name: "",
            id: "",
            serviceError: false,
            nProducts: 0,
            productsToShow: [],
            copyCategoryDisabled: false,
            showUpdatePopup: false,
            updateCategoryNameRemainingLength: 0,
            errorUpdateCategoryAlreadyExists: false,
            errorUpdateCategoryGeneric: false,
            buttonUpdateCategoryDisabled: true,
            updateCategoryName: "",
            updateCategoryColor: "",
            topUpdateMenu: 0,
            leftUpdateMenu: 0,
            showCopyConfirmDialog: false,
            showDeleteConfirmDialog: false,
            showDeleteProductsConfirmDialog: false
        }

        this.pagination = new Pagination(10);
        this.deleteFromCategoryCallback = this.deleteFromCategoryCallback.bind(this);
        this.updateCategoryNameInput = createRef();
        this.handleUpdateCategoryNameKeyDown = this.handleUpdateCategoryNameKeyDown.bind(this);
        this.handleUpdateCategoryNameChanges = this.handleUpdateCategoryNameChanges.bind(this);
        this.handleUpdateCategoryColorChanges = this.handleUpdateCategoryColorChanges.bind(this);
    }

    private handleUpdateCategoryPopup(){
        let main = $('#main-container-category-details')
        let mainHeight = main!!.height();

        let top = $('#category-details-header-button-update').offset()?.top;
        let newTop = top! + 19 + 10;
        this.setState({topUpdateMenu: newTop});
        main.height(mainHeight!!.toString());

        this.setState({showUpdatePopup: true});
        this.setState({updateCategoryName: this.state.name});
        this.setState({updateCategoryColor: this.state.color});
    }

    private closeUpdatePopup(){
        this.setState({buttonUpdateCategoryDisabled: true});
        this.setState({showUpdatePopup: false});
    }

    private goToAddProduct(history: any){
        console.log("[CategoryDetailsPage] goToAddProduct called!");
        let categoryDto = new CategoryDto(
            this.state.categoryId, this.state.color, this.state.name, null
        );
        dataStore.publishCategoryFromAddProduct(categoryDto);
        history.push('/addProduct/first');
    }
    
    componentDidMount(){
        if (this.props.match === undefined || this.props.match.params === undefined || this.props.match.params.id === undefined) {
            console.log("[CategoryDetailsPage] Error for missing category id!");
            this.props.history.replace('/catalog');
        } else {
            let categoryIdFromParams = this.props.match.params.id;
            this.setState({categoryId: categoryIdFromParams});
            let params = querystring.parse(this.props.location.search.replace("?", ''));
            if(!Mapper.checkCategoryMandatoryParams(params)){
                console.log("[CategoryDetailsPage] Error for missing params!");
                this.props.history.replace('/catalog');
            } else {
                GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Dettaglio categoria', {});
                let color = params.color;
                //@ts-ignore
                let name = decodeURIComponent(params.name);
                this.setState({name: name});
                //@ts-ignore
                this.setState({color: color});
                this.setState({id: categoryIdFromParams}, () => {
                    this.loadDetails();
                });

                if(this.props.location.state !== undefined){
                    const { data } = this.props.location.state;
                    if(data.operation !== undefined && data.operation === 'deleteProductFromDetail'){
                        window.history.pushState(null, '', '/');
                        window.history.pushState(null, '', this.props.history.location.pathname + this.props.location.search.replace);
                        sessionStorageInstance.setData('useProductCache', '1');
                        let productToDelete: IProductDto = data.toDelete;
                        if(productToDelete !== undefined){
                            console.log("[Delete product] product: " + productToDelete.productId);
                            setTimeout(() => {
                                //@ts-ignore
                                let top = document.getElementById(productToDelete.productId)?.offsetTop;
                                console.log(top);
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: top
                                }, 350);
                                setTimeout(() => {
                                    this.deleteProductFromCatalog(productToDelete);
                                }, 400);
                            }, 0); // Permit to call loadDetails first and after set state on tab selected 
                        }
                    }
                }
            }
        }
        window.scrollTo(0, 0);
    }
    
    componentDidUpdate(){
        let main = $('#main-container-category-details')
        if(main !== undefined){
            main.css('height', 'auto');
        }
    }

    private loadDetails(){
        if(!sessionStorageInstance.hasKey('useProductCache')){
            this.setState({isLoading: true});
            MposWebPortalApi.getInstance().getProductsForCategory(this.state.id).subscribe((response) => {
                this.setState({isLoading: false});
                this.setState({serviceError: false});
                this.setState({products: (response.products !== null && response.products !== undefined) ? 
                    this.sortProductsForName(response.products) : []}, () => {
                        this.setState({nProducts: this.state.products?.length!!});
                        this.pagination.setInputData(this.sortProductsForName(this.state.products!!));
                        this.getProductsToShow();
                        dataStore.publishProductsData(this.state.products!);
                    });
            }, () => {
                this.setState({isLoading: false});
                this.setState({serviceError: true});
                this.setState({products: null});
                this.setState({nProducts: 0});
            })
        } else {
            this.setState({isLoading: false});
            sessionStorageInstance.removeData('useProductCache');
            console.log("[CatalogPage] CategoryDetailsPage Cached");
            let cachedProducts = this.props.cachedProducts;
            this.setState({serviceError: false});
            this.setState({
                products: this.sortProductsForName(cachedProducts)
            }, () => {
                this.setState({nProducts: this.state.products?.length!!});
                this.pagination.setInputData(this.sortProductsForName(this.state.products!!));
                this.getProductsToShow();
            })
        }
    }

    private reload(){
        this.setState({isLoading: false});
        MposWebPortalApi.getInstance().getProductsForCategory(this.state.id).subscribe((response) => {
            this.setState({serviceError: false});
            this.setState({products: (response.products !== null && response.products !== undefined) ? 
                this.sortProductsForName(response.products) : []}, () => {
                    this.setState({nProducts: this.state.products?.length!!});
                    this.pagination.setInputData(this.sortProductsForName(this.state.products!!));
                    this.getProductsToShow();
                    dataStore.publishProductsData(this.state.products!);
                });
        }, () => {
            this.setState({serviceError: true});
            this.setState({products: null});
            this.setState({nProducts: 0});
        })
    }

    private runProductDeleteAnimation(product: IProductDto, callback: any){
        let id = product.productId!;
        $('#' + id).addClass('remove-product-details-animation');
        $('#' + id).on('transitionend webkitTransitionEnd oTransitionEnd', function() {
            $('#' + id).removeClass('remove-product-details-animation');
            callback();
        });
    }

    private deleteProductFromCatalog(product: IProductDto){
        let index = _.findIndex(this.state.products, {productId: product.productId});
        let old = this.state.products!;
        old.splice(index, 1);
        MposWebPortalApi.getInstance().deleteProduct(product).subscribe((response) => {
            eventDispatcher.sendEvent(EventType.CLOSE_PRODUCT_POPUP);
            if(response){
                this.runProductDeleteAnimation(product, () => {
                    this.reload()
                });
            } else {
                this.props.history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la cancellazione del prodotto.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "CatalogPage", operation: "deleteCategory" }
                })
            }
        }, () => {
            eventDispatcher.sendEvent(EventType.CLOSE_PRODUCT_POPUP);
            this.props.history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la cancellazione del prodotto.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "CatalogPage", operation: "deleteCategory" }
            })
        })
    }

    private sortProductsForName(products: IProductDto[]): IProductDto[] {
        if(products !== undefined && products !== null){
            return products.sort(function(a, b){
                if(a.name !== null && b.name !== null){
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                }
                return 0;
            })
        }

        return [];
    }

    private getProductsToShow(){
        this.setState({productsToShow: this.pagination.getNext()});
    }

    private renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={""} hideBorder={true} background={this.state.color} buttonContentColor={'#FFFFFF'} isSpecial>
                <div className={"category-details-header-content"}>
                    <p className={"category-details-header-name"}>{this.state.name}</p>
                    {
                        <Button id={"category-details-header-button-update"}
                            onClick={() => { this.handleUpdateCategoryPopup() }} disableRipple>{"Modifica".toUpperCase()}</Button>
                    }
                    {
                        this.state.showUpdatePopup && <div id={this.state.categoryId + "_overlay"} className={"overlay-class"}></div>
                    }
                    {
                        this.state.showUpdatePopup && this.renderUpdateMenu()
                    }
                </div>
            </HeaderDesktop>);
    }

    private renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile showBack={true} showLogout={false} showTitle={false} hideBorder={true} background={this.state.color} buttonContentColor={'#FFFFFF'} isSpecial>
                <div className={"user-details-header-content"}>
                    <p className={"user-details-header-username"}>{this.state.name}</p>
                    {
                        <Button id={"category-details-header-button-update"}
                            onClick={() => { this.handleUpdateCategoryPopup() }} disableRipple>{"Modifica".toUpperCase()}</Button>
                    }
                    {
                        this.state.showUpdatePopup && <div id={this.state.categoryId + "_overlay"} className={"overlay-class"}></div>
                    }
                    {
                        this.state.showUpdatePopup && this.renderUpdateMenu()
                    }
                </div>
            </HeaderMobile>);
    }

    private hideHelperText(input: string){
        $('#' + input).css('visibility', 'hidden');
    }

    private showHelperText(input: string){
        $('#' + input).css('visibility', 'visible');
    }

    private handleUpdateCategoryNameKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[CategoryButton] Done clicked!");
                if(this.updateCategoryNameInput !== undefined){
                    this.updateCategoryNameInput.current.blur();
                }
            }
        }
    }
    
    private handleUpdateCategoryNameChanges(event: any){
        this.setState({errorUpdateCategoryAlreadyExists: false});
        this.setState({errorUpdateCategoryGeneric: false});
        this.setState({updateCategoryName: event.target.value}, () => {
            this.setState({buttonUpdateCategoryDisabled: (this.state.updateCategoryName.length === 0)})
        });
        let computedLength = this.MAX_CATEGORY_NAME_LENGTH - event.target.value.length;
        this.setState({updateCategoryNameRemainingLength: computedLength});
    }

    private handleUpdateCategoryColorChanges(event: any){
        this.setState({updateCategoryColor: event.target.value});
        this.setState({buttonUpdateCategoryDisabled: false});
    }

    private updateCategory(){
        let id = this.state.categoryId;
        let nProducts = this.state.nProducts;
        let name = this.state.updateCategoryName;
        let color = this.state.updateCategoryColor;
        let newCategory = new CategoryDto(id, color, name, nProducts.toString());
        if(newCategory.name?.toLowerCase() === "senza categoria"){
            newCategory.name = null;
        }
        MposWebPortalApi.getInstance().updateCategory(newCategory).subscribe((result) => {
            console.log("[CategoryDetailsPage] updateCategory success " + result);
            if(result){
                this.setState({name: name});
                this.setState({color: color});
                this.closeUpdatePopup();
            }
        }, (error) => {
            console.log("[CategoryDetailsPage] updateCategory");
            if(error.status === 400){
                this.setState({errorUpdateCategoryAlreadyExists: true});
                this.setState({errorUpdateCategoryGeneric: false});
            } else {
                this.setState({errorUpdateCategoryAlreadyExists: false});
                this.setState({errorUpdateCategoryGeneric: true});
            }
        });
    }

    private renderUpdateMenu(): JSX.Element {
        if(this.state.name.toLowerCase() === 'senza categoria'){
            // No category, cannot change name with form
            return <div id={this.state.categoryId + "_update"} className={'category-menu-container-nocategory'} style={{top: this.state.topUpdateMenu, left: 0, right: 0, marginLeft: 'auto', marginRight: 'auto'}}>
                <div className={"category-menu-options-main-content"}>
                    <div style={{width: '100%'}} id={"category-menu-options-inner-content"}>
                        <div className={"category-menu-options-main-title-content"}>
                            <p className={"category-menu-options-main-title"}>{"Modifica nome categoria"}</p>
                            <div onClick={() => this.closeUpdatePopup()} style={{cursor: 'pointer'}}>
                                <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'}/>
                            </div>
                        </div>
                        <div className={"category-menu-options-main-row-content-nocategory"}></div>
                        <p className={"insert-new-category-color-label-nocategory"}>Scegli un colore per la categoria</p>
                        <div className={"insert-new-category-radio-color-container"}>
                                {
                                    _.map(colors.colors, (value: object, index: number) => {
                                        // @ts-ignore
                                        let key: string = value['key'];
                                        // @ts-ignore
                                        let hexValue: string = value['value'];
                                        return (
                                            <div key={key} className={index === 0 ? 'insert-new-category-radio-content-first' : index === (colors.colors.length - 1) ? 'insert-new-category-radio-content-last' : 'insert-new-category-radio-content'}>
                                                {
                                                    <div className="radio-input-container">
                                                        <Radio disableRipple color="default"
                                                            checked={this.state.updateCategoryColor === hexValue} value={hexValue} onChange={this.handleUpdateCategoryColorChanges}
                                                            checkedIcon={<span className={"radio-icon radio-checked-icon"} style={{backgroundColor: hexValue}} />}
                                                            icon={<span className={"radio-icon"} style={{backgroundColor: hexValue}} />}/>
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })
                                }
                        </div>
                        <Button id={"update-category-button-create"} disableRipple disableFocusRipple disableTouchRipple disabled={this.state.buttonUpdateCategoryDisabled} onClick={() => {
                            this.updateCategory();
                        }}>{"MODIFICA CATEGORIA"}</Button>
                    </div>
                </div>
            </div>
        } else {
            // Other categories...show complete change popup
            return <div id={this.state.categoryId + "_update"} className={'category-menu-container'} style={{top: this.state.topUpdateMenu, left: 0, right: 0, marginLeft: 'auto', marginRight: 'auto'}}>
                <div className={"category-menu-options-main-content"}>
                    <div style={{width: '100%'}} id={"category-menu-options-inner-content"}>
                        <div className={"category-menu-options-main-title-content"}>
                            <p className={"category-menu-options-main-title"}>{"Modifica nome categoria"}</p>
                            <div onClick={() => this.closeUpdatePopup()} style={{cursor: 'pointer'}}>
                                <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'}/>
                            </div>
                        </div>
                        <div className={"category-menu-options-main-row-content"}></div>
                        <TextField id={"update-category-name-field"} label="Inserisci nome categoria" type={"text"}
                            inputRef={this.updateCategoryNameInput} onKeyDown={this.handleUpdateCategoryNameKeyDown} inputProps={{ maxLength: this.MAX_CATEGORY_NAME_LENGTH }}
                            value={this.state.updateCategoryName}
                            error={this.state.errorUpdateCategoryAlreadyExists || this.state.errorUpdateCategoryGeneric}
                            onChange={this.handleUpdateCategoryNameChanges}
                            helperText={"-" + this.state.updateCategoryNameRemainingLength}
                            onFocus={() => this.showHelperText('update-category-name-field-helper-text')}
                            onBlur={() => this.hideHelperText('update-category-name-field-helper-text')}
                        />
                        { this.state.errorUpdateCategoryAlreadyExists && <p className={"insert-new-category-error-message"}>
                            Nome categoria già esistente. Inseriscine un altro.
                        </p> }
                        { this.state.errorUpdateCategoryGeneric && <p className={"insert-new-category-error-message"}>
                            {"Si è verificato un errore durante la modifica della categoria."}
                        </p> }
                        <p className={(this.state.errorUpdateCategoryAlreadyExists || this.state.errorUpdateCategoryGeneric) ? "insert-new-category-color-label-with-error" : "insert-new-category-color-label"}>Scegli un colore per la categoria</p>
                        <div className={"insert-new-category-radio-color-container"}>
                                {
                                    _.map(colors.colors, (value: object, index: number) => {
                                        // @ts-ignore
                                        let key: string = value['key'];
                                        // @ts-ignore
                                        let hexValue: string = value['value'];
                                        return (
                                            <div key={key} className={index === 0 ? 'insert-new-category-radio-content-first' : index === (colors.colors.length - 1) ? 'insert-new-category-radio-content-last' : 'insert-new-category-radio-content'}>
                                                {
                                                    <div className="radio-input-container">
                                                        <Radio disableRipple color="default"
                                                            checked={this.state.updateCategoryColor === hexValue} value={hexValue} onChange={this.handleUpdateCategoryColorChanges}
                                                            checkedIcon={<span className={"radio-icon radio-checked-icon"} style={{backgroundColor: hexValue}} />}
                                                            icon={<span className={"radio-icon"} style={{backgroundColor: hexValue}} />}/>
                                                    </div>
                                                }
                                            </div>
                                        );
                                    })
                                }
                        </div>
                        <Button id={"update-category-button-create"} disableRipple disableFocusRipple disableTouchRipple disabled={this.state.buttonUpdateCategoryDisabled} onClick={() => {
                            this.updateCategory();
                        }}>{"MODIFICA CATEGORIA"}</Button>
                    </div>
                </div>
            </div>
        }
    }

    private deleteFromCategoryCallback(product: IProductDto){
        console.log("[deleteFromCategoryCallback] " + JSON.stringify(product));
        let request = new AddOrRemoveProductFromCategory(this.state.categoryId, [
            product.productId!
        ]);
        let index = _.findIndex(this.state.products, {productId: product.productId});
        let old = this.state.products!;
        MposWebPortalApi.getInstance().removeProductsFromCategory(request).subscribe((response) => {
            if(response){
                this.runDeleteAnimation(product, () => {
                    console.log("[CatalogDetailsPage] called!")
                    old.splice(index, 1);
                    this.setState({products: old}, () => {
                        this.loadDetails();
                    });
                });
            } else {
                this.props.history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la cancellazione del prodotto dalla categoria.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "CategoryDetailsPage", operation: "deleteProduct" }
                })
            }
        }, () => {
            this.props.history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la cancellazione del prodotto dalla categoria.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "CategoryDetailsPage", operation: "deleteProduct" }
            })
        })
    }

    private runDeleteAnimation(product: IProductDto, callback: any){
        let id = product.productId!;
        $('#' + id).addClass('remove-animation');
        $('#' + id).on('transitionend webkitTransitionEnd oTransitionEnd', function() {
            $('#' + id).removeClass('remove-animation');
            callback();
        });
    }

    private renderSkeleton(): JSX.Element {
        return <div className={"category-details-product-table-container"}>
            <div className={"category-details-product-row-skeleton-first"}> 
                <div className={"category-details-product-column category-details-product-column-left"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div>  
                <div className={"category-details-product-column category-details-product-column-right"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div> 
            </div>
            <div className={"category-details-product-row-skeleton"}> 
                <div className={"category-details-product-column category-details-product-column-left"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div>  
                <div className={"category-details-product-column category-details-product-column-right"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div> 
            </div>
            <div className={"category-details-product-row-skeleton"}> 
                <div className={"category-details-product-column category-details-product-column-left"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div>  
                <div className={"category-details-product-column category-details-product-column-right"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div> 
            </div>
            <div className={"category-details-product-row-skeleton"}> 
                <div className={"category-details-product-column category-details-product-column-left"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div>  
                <div className={"category-details-product-column category-details-product-column-right"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div> 
            </div>
            <div className={"category-details-product-row-skeleton"}> 
                <div className={"category-details-product-column category-details-product-column-left"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div>  
                <div className={"category-details-product-column category-details-product-column-right"}>
                    <Skeleton className={"category-details-product-skeleton"}/>
                </div> 
            </div>
        </div>
    }

    renderProductsTable(): JSX.Element {
        let elements = new Array<JSX.Element[]>();
        let temporary: JSX.Element[] = [];
        let isNoCategory = this.state.name.toLowerCase() === 'senza categoria';
        _.forEach(this.state.productsToShow, (value: IProductDto, index: number) => {
            if((index % 2) === 0){
                temporary.push(
                    <div className={"category-details-product-column category-details-product-column-left"}>
                        <Route render={({history}) => {
                            return <ProductButton product={value} history={history} page={'CategoryDetailsPage'} deleteFromCategory={this.deleteFromCategoryCallback}
                                completePathPage={this.props.history.location.pathname + this.props.location.search} isNoCategory={isNoCategory}/>
                        }} />
                    </div>
                )
            } else {
                temporary.push(
                    <div className={"category-details-product-column category-details-product-column-right"}>
                        <Route render={({history}) => {
                            return <ProductButton product={value} history={history} page={'CategoryDetailsPage'} deleteFromCategory={this.deleteFromCategoryCallback}
                                completePathPage={this.props.history.location.pathname + this.props.location.search} isNoCategory={isNoCategory}/>
                        }} />
                    </div>
                )
            }

            if(temporary.length === 2){
                elements.push(temporary);
                temporary = [];
            } else {
                if(index === (this.state.productsToShow?.length! - 1)){
                    elements.push(temporary);
                    temporary = [];
                }
            }
        });
        
        return (<div className={"category-details-product-table-container"}>
            {
                _.map(elements, (rowElements) => {
                    return <div className={"category-details-product-row"}>
                        {_.map(rowElements, (columnElement) => {
                            return columnElement;
                        })}
                    </div>
                })
            }
        </div>)
    }

    private toggleCopyConfirmDialog(){
        this.setState({showCopyConfirmDialog: !this.state.showCopyConfirmDialog});
    }

    private toggleDeleteConfirmDialog(){
        this.setState({showDeleteConfirmDialog: !this.state.showDeleteConfirmDialog});
    }

    private toggleDeleteProductsConfirmDialog(){
        this.setState({showDeleteProductsConfirmDialog: !this.state.showDeleteProductsConfirmDialog});
    }

    private startCopyCategory(history: any){
        window.history.pushState(null, '', '/');
        history.push('/catalog', {data: {operation: 'copyCategoryFromDetails', categoryId: this.state.categoryId, name: this.state.name, color: this.state.color}})
    }

    private startDeleteCategory(history: any){
        window.history.pushState(null, '', '/');
        history.push('/catalog', {data: {operation: 'deleteCategoryFromDetails', categoryId: this.state.categoryId, name: this.state.name, color: this.state.color}})
    }

    private startDeleteProductsOfNoCategory(history: any){
        window.history.pushState(null, '', '/');
        history.push('/catalog', {data: {operation: 'deleteNoCategoryProducts', categoryId: this.state.categoryId, name: this.state.name, color: this.state.color}})
    }

    render(){
        return this.state.serviceError ? <ServiceUnavailablePage/> : <div id={"main-container-category-details"}>
            {
                this.state.showCopyConfirmDialog && <Route render={({history}) => {
                    return <ConfirmDialog id={"category-details-copy-dialog"} show={this.state.showCopyConfirmDialog} onClose={() => { this.toggleCopyConfirmDialog() }} title={"Duplica categoria"}
                    content={"Nella pagina del tuo catalogo troverai una copia di questa categoria con all’interno tutti i suoi prodotti."}
                    buttonNoText={"ANNULLA"} buttonYesText={"CONFERMA"} onConfirm={() => { this.startCopyCategory(history) }} />
                }}/>
            }
            {
                this.state.showDeleteConfirmDialog && <Route render={({history}) => {
                    return <ConfirmDialog id={"category-details-delete-dialog"} show={this.state.showDeleteConfirmDialog} onClose={() => { this.toggleDeleteConfirmDialog() }} title={"Elimina categoria"}
                    content={"Se elimini la categoria non sarà più disponibile per nessun prodotto."}
                    buttonNoText={"ANNULLA"} buttonYesText={"CONFERMA"} onConfirm={() => { this.startDeleteCategory(history) }} />
                }}/>
            }
            {
                this.state.showDeleteProductsConfirmDialog && <Route render={({history}) => {
                    return <ConfirmDialog id={"category-details-delete-dialog"} show={this.state.showDeleteProductsConfirmDialog} onClose={() => { this.toggleDeleteProductsConfirmDialog() }} title={"Elimina prodotti"}
                    content={"Eliminando tutti i prodotti all’interno di questa categoria, eliminerai anche la categoria stessa."}
                    buttonNoText={"ANNULLA"} buttonYesText={"CONFERMA"} onConfirm={() => { this.startDeleteProductsOfNoCategory(history) }} />
                }}/>
            }
            <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader()} />
            <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader()} />
            <div className={"category-details-container-content"}>
                <div className={"category-details-add-product-box"}>
                    <p className={"category-details-add-product-label"}>Inserisci il prodotto all’interno della categoria</p>
                    <Route render={({history}) => {
                        return <Button id={"category-details-button-add-product"} onClick={() => {
                            this.goToAddProduct(history);
                        }}>AGGIUNGI PRODOTTO</Button>;
                    }}/>
                </div>
                {!this.state.isLoading && <p className={"category-details-label-nproducts"}>{"PRODOTTI DELLA CATEGORIA (" + this.state.nProducts + ")"}</p>}
                {
                    this.state.isLoading ? this.renderSkeleton() : this.renderProductsTable()
                }
                {this.pagination.hasMoreElements() && <Button id={"category-details-product-show-more"} onClick={() => {this.getProductsToShow()}} disableRipple>{"Mostra di più".toUpperCase()}</Button>}
                <div className={"category-details-row"}></div>
                {
                    [
                        (this.state.name.toLowerCase() === "senza categoria") && <div className={"category-details-action-box"}>
                            <p className={"category-details-delete-button"} onClick={() => {
                                    this.toggleDeleteProductsConfirmDialog();
                            }}>ELIMINA PRODOTTI</p>
                        </div>,
                        (this.state.name.toLowerCase() !== "senza categoria") && <div className={"category-details-action-box"}>
                            <p className={!this.state.copyCategoryDisabled ? "category-details-copy-button" : "category-details-copy-button-disabled"}
                                onClick={this.state.copyCategoryDisabled ? undefined : () => {
                                    this.toggleCopyConfirmDialog();
                            }}>DUPLICA</p>
                            <div className={"category-details-vertical-row"}></div>
                            <p className={"category-details-delete-button"} onClick={() => {
                                    this.toggleDeleteConfirmDialog();
                            }}>ELIMINA</p>
                        </div>
                    ]
                }
                
            </div>
        </div>
    }

}